import { Expose } from 'class-transformer';

export class ResourcesPriceRulesResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'resource_id' })
  resourceId: number;
  @Expose({ name: 'min_hours' })
  minHours: number;
  @Expose({ name: 'booking_price' })
  bookingPrice: number;
}
